import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    wrapper: {
      margin: '32px 0 24px',
    },
    subtitle: {
      color: palette.gray,
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontWeight: 400,
    },
    ...overrideClasses,
  });
